import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
});

API.interceptors.request.use((config) => {
  const token    = localStorage.getItem('blixo_token');
  const tenantId = process.env.REACT_APP_TENANT_ID || 'default';
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['x-tenant-id'] = tenantId;
  return config;
});

// Auth
export const getMe        = ()     => API.get('/auth/me');
export const storePublicKey = (pk) => API.post('/auth/keys', { publicKey: pk });

// Conversations
export const getConversations = ()               => API.get('/conversations');
export const getMessages      = (userId, page=1) => API.get(`/conversations/${userId}/messages?page=${page}`);

// Messages
export const markAsRead     = (userId)           => API.put(`/messages/${userId}/read`);
export const uploadMedia    = (formData)         => API.post('/messages/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const reactToMessage = (messageId, emoji) => API.put(`/messages/${messageId}/react`, { emoji });
export const deleteMessage  = (messageId, forAll)=> API.delete(`/messages/${messageId}`, { data: { deleteForEveryone: forAll } });

// Users
export const getUserProfile = ()       => API.get('/users/profile');
export const updateProfile  = (data)   => API.put('/users/profile', data);
export const getAllUsers     = ()       => API.get('/users/all');
export const blockUser       = (id)    => API.put(`/users/${id}/block`);
export const unblockUser     = (id)    => API.put(`/users/${id}/unblock`);
export const setVip          = (id)    => API.put(`/users/${id}/vip`);

// Offers & Games
export const getOffers = () => API.get('/offers');
export const getGames  = () => API.get('/games');
export const createOffer = (data) => API.post('/offers', data);
export const deleteOffer = (id)   => API.delete(`/offers/${id}`);
export const createGame  = (data) => API.post('/games', data);
export const updateGame  = (id, data) => API.put(`/games/${id}`, data);
export const deleteGame  = (id)   => API.delete(`/games/${id}`);

// Bulk messaging
export const sendBulkMessage = (data) => API.post('/messages/bulk', data);

// Superadmin
export const getSuperStats         = ()    => API.get('/super/stats');
export const getSuperTenants       = ()    => API.get('/super/tenants');
export const getSuperUsers         = (tid) => API.get(`/super/users${tid ? `?tenantId=${tid}` : ''}`);
export const getSuperConversations = (tid) => API.get(`/super/conversations${tid ? `?tenantId=${tid}` : ''}`);
export const getSuperMessages      = (uid) => API.get(`/super/messages/${uid}`);
export const superBlockUser        = (uid) => API.put(`/super/users/${uid}/block`);

export default API;
